import { __decorate } from "tslib";
import { LitElement, html, customElement } from 'lit-element';
const count = 1000;
const list = [];
for (let i = 0; i < count; i++) {
    list.push(i);
}
let DemoStaticLoop = class DemoStaticLoop extends LitElement {
    constructor() {
        super(...arguments);
        this.list = list;
    }
    render() {
        return html `
      <div cds-layout="grid cols:1 gap:lg">
        ${this.list.map(() => html `<demo-static></demo-static>`)}
      </div>
    `;
    }
    createRenderRoot() {
        return this;
    }
};
DemoStaticLoop = __decorate([
    customElement('demo-static-loop')
], DemoStaticLoop);
export { DemoStaticLoop };
//# sourceMappingURL=demo.static-loop.js.map